import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { findOverflowScrollParent } from '@atlaskit/editor-common/ui';
import { Dropzone } from '@atlaskit/media-picker';
import PickerFacadeProvider from './PickerFacadeProvider';
var selector = function selector(states) {
  var _states$mediaState, _states$mediaState2;
  return {
    options: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.options,
    handleDrag: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.handleDrag
  };
};
var DropzoneWrapperInternal = function DropzoneWrapperInternal(_ref) {
  var api = _ref.api,
    isActive = _ref.isActive,
    featureFlags = _ref.featureFlags,
    editorDomElement = _ref.editorDomElement,
    appearance = _ref.appearance,
    mediaClientConfig = _ref.mediaClientConfig,
    config = _ref.config,
    pickerFacadeInstance = _ref.pickerFacadeInstance;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['media'], selector),
    options = _useSharedPluginState.options,
    handleDrag = _useSharedPluginState.handleDrag;
  var _ref2 = options || {},
    customDropzoneContainer = _ref2.customDropzoneContainer;

  // Ignored via go/ees005
  // eslint-disable-next-line @atlaskit/editor/no-as-casting
  var editorHtmlElement = editorDomElement;
  var scrollParent = appearance === 'full-page' && findOverflowScrollParent(editorHtmlElement);
  var container = customDropzoneContainer || (scrollParent ? scrollParent : editorHtmlElement);
  var dropzoneConfig = _objectSpread(_objectSpread({}, config), {}, {
    container: container
  });
  return isActive ? /*#__PURE__*/React.createElement(Dropzone, {
    mediaClientConfig: mediaClientConfig,
    config: dropzoneConfig,
    onError: pickerFacadeInstance.handleUploadError,
    onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
    onEnd: pickerFacadeInstance.handleReady,
    onDragEnter: function onDragEnter() {
      return handleDrag === null || handleDrag === void 0 ? void 0 : handleDrag('enter');
    },
    onDragLeave: function onDragLeave() {
      return handleDrag === null || handleDrag === void 0 ? void 0 : handleDrag('leave');
    },
    featureFlags: featureFlags
  }) : null;
};
export var DropzoneWrapper = function DropzoneWrapper(_ref3) {
  var api = _ref3.api,
    isActive = _ref3.isActive,
    featureFlags = _ref3.featureFlags,
    editorDomElement = _ref3.editorDomElement,
    appearance = _ref3.appearance;
  return /*#__PURE__*/React.createElement(PickerFacadeProvider, {
    api: api,
    analyticsName: "dropzone"
  }, function (_ref4) {
    var mediaClientConfig = _ref4.mediaClientConfig,
      config = _ref4.config,
      pickerFacadeInstance = _ref4.pickerFacadeInstance;
    return /*#__PURE__*/React.createElement(DropzoneWrapperInternal, {
      api: api,
      isActive: isActive,
      featureFlags: featureFlags,
      editorDomElement: editorDomElement,
      appearance: appearance,
      mediaClientConfig: mediaClientConfig,
      config: config,
      pickerFacadeInstance: pickerFacadeInstance
    });
  });
};